export class DisplayResult {
  listName: string;
  listIcon: string;
  candidateNames: string[];
  candidateIcons: Array<string>;
  results: Array<Array<number>>;
  elected: Array<boolean>;
  electedCount: number;

  constructor(
    listName: string,
    listIcon: string,
    candidateNames: string[],
    candidateIcons: Array<string>,
    results: Array<Array<number>>,
    elected: Array<boolean>
  ) {
    this.listName = listName;
    this.listIcon = listIcon;
    this.candidateNames = candidateNames;
    this.candidateIcons = candidateIcons;
    this.results = results;
    this.elected = elected;
    this.electedCount = elected.filter(it => it === true).length;
  }
}
